import React from "react";
import { User } from "@/integrations/neon";
import { Dashboard } from "./Dashboard";

interface DashboardWrapperProps {
  user: User;
  onSignOut: () => void;
}

export const DashboardWrapper: React.FC<DashboardWrapperProps> = ({ user, onSignOut }) => (
  <Dashboard user={user} onSignOut={onSignOut} />
);
